import qs from "qs";

import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath } from "../../utils";
import MenuActionApi from "../../services/api/MenuActions";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings.js";

function handleError(err) {
  console.log("error in MenuActions actions:", err);
}

export const setMenus = (payload) => {
  return {
    type: ActionTypes.SET_MENUS,
    payload,
  };
};

export const setFailedToFetchMenu = () => {
  return {
    type: ActionTypes.SET_FAILED_TO_FETCH_MENU,
  };
};

export const getMenusList = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await MenuActionApi.getMenusList();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setMenus(response));
    } else {
      dispatch(setFailedToFetchMenu());
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(setFailedToFetchMenu());
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const setMenuActions = (payload) => {
  return {
    type: ActionTypes.SET_MENU_ACTIONS,
    payload,
  };
};

export const checkMenuActionsAllowed = (menuName) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const arr = Object.values(getPath(MenuActionsMappings, menuName, {}));
    const payload = { name: arr };
    const queryParams = qs.stringify(payload, {
      addQueryPrefix: true,
      arrayFormat: "repeat",
    });
    const response = await MenuActionApi.checkMenuActionAllowed(queryParams);
    dispatch(setLoader(false));
    if (response) {
      const data = {
        menuName: menuName,
        status_map: getPath(response, "status_map", {}),
      };
      dispatch(setMenuActions(data));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
